const alderReveal = () => {
  const items = document.querySelectorAll('.ar-reveal:not([data-ar-ready])');

  if (!items.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => {
      item.dataset.arReady = 'true';
      item.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  items.forEach((item) => {
    item.dataset.arReady = 'true';
    observer.observe(item);
  });
};

const alderReviewKeyboard = () => {
  document.querySelectorAll('.ar-reviews__track:not([data-ar-keyboard])').forEach((track) => {
    track.dataset.arKeyboard = 'true';
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * 0.75 * direction, behavior: 'smooth' });
    });
  });
};

const alderInit = () => {
  alderReveal();
  alderReviewKeyboard();
  elevnCarouselControls();
};

document.addEventListener('DOMContentLoaded', alderInit);
document.addEventListener('shopify:section:load', alderInit);

const elevnCarouselControls = () => {
  document
    .querySelectorAll(
      'button[data-elevn-carousel-action][aria-controls]:not([data-elevn-carousel-ready])'
    )
    .forEach((button) => {
    const carousel = document.getElementById(button.getAttribute('aria-controls'));
    if (!carousel || carousel.tagName !== 'SCROLL-CAROUSEL') return;

      button.dataset.elevnCarouselReady = 'true';

      const getStep = () => {
      const selector = carousel.getAttribute('selector') || ':scope > *';
      const items = Array.from(carousel.querySelectorAll(selector)).filter(
        (item) => item.offsetParent !== null
      );

        return items.length > 1
          ? Math.abs(items[1].offsetLeft - items[0].offsetLeft)
          : Math.max(carousel.clientWidth * 0.8, 1);
      };

      const syncButtons = () => {
        const maxScroll = Math.max(carousel.scrollWidth - carousel.clientWidth, 0);
        document
          .querySelectorAll('button[data-elevn-carousel-action][aria-controls]')
          .forEach((control) => {
            if (control.getAttribute('aria-controls') !== carousel.id) return;
            control.disabled =
              control.dataset.elevnCarouselAction === 'prev'
                ? carousel.scrollLeft <= 2
                : carousel.scrollLeft >= maxScroll - 2;
          });
      };

      button.addEventListener('click', () => {
      const direction = button.dataset.elevnCarouselAction === 'next' ? 1 : -1;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';

        carousel.scrollBy({ left: getStep() * direction, behavior });
        window.setTimeout(syncButtons, 500);
      });

      if (carousel.dataset.elevnCarouselTracked !== 'true') {
        carousel.dataset.elevnCarouselTracked = 'true';
        carousel.addEventListener('scroll', syncButtons, { passive: true });
      }

      syncButtons();
    });
};

elevnCarouselControls();

